import { useFormContext } from 'react-hook-form';

import type { ExamCenterProctorDetailsFormInput } from './exam-center-proctor-details-form-schema';

export const useExamCenterProctorDetailsFormContext =
  useFormContext<ExamCenterProctorDetailsFormInput>;
